<div class="section-addressGroup" [ngClass]="addressType + 'Address'">
  <form nz-form nzLayout="vertical" [formGroup]="form">
    <div nz-row [formGroupName]="addressType + 'Address'">
      <div nz-col nzSpan="24">
        <mat-form-field id="address-line1-input" class="line1-input" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ getFriendlyFieldName('line1') }}</mat-label>
          <input 
            type="text"
            matInput
            formControlName="line1"
            [matAutocomplete]="auto"
            (input)="onInput($event.target?.value)">
          
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChange($event)" [displayWith]="displayLine1Selection">
              @for (suggestion of (suggestions$ | async); track suggestion) {
                <mat-option [value]="suggestion">{{ suggestion['FullAddress'] }}</mat-option>
              }
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field id="address-line2-input" class="address-line2-input" appearance="outline" subscriptSizing="dynamic" floatLabel="always">
          <mat-label>{{ getFriendlyFieldName('line2') }}</mat-label>
          <input 
            type="text"
            matInput
            formControlName="line2"
            disabled>
        </mat-form-field>

        <div class="town-postCode-box">
          <div nz-row nzGutter="24">
            <div nz-col nzSpan="12">
              <mat-form-field id="address-townOrCity-input" class="address-townOrCity-input" appearance="outline" subscriptSizing="dynamic" floatLabel="always">
                <mat-label>{{ getFriendlyFieldName('townOrCity') }}</mat-label>
                <input 
                  type="text"
                  matInput
                  formControlName="townOrCity"
                  disabled>
              </mat-form-field>
            </div>
            
            <div nz-col nzSpan="12">
              <mat-form-field id="address-postCode-input" class="address-postCode-input" appearance="outline" subscriptSizing="dynamic" floatLabel="always">
                <mat-label>{{ getFriendlyFieldName('postCode') }}</mat-label>
                <input 
                  type="text"
                  matInput
                  formControlName="postCode"
                  disabled>
              </mat-form-field>
            </div>
          </div>
        </div>

        <mat-form-field id="address-province-input" class="address-province-input" appearance="outline" subscriptSizing="dynamic" floatLabel="always">
          <mat-label>{{ getFriendlyFieldName('province') }}</mat-label>
          <input 
            type="text"
            matInput
            formControlName="province"
            disabled>
        </mat-form-field>

        <mat-form-field id="address-country-input" class="address-country-input" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ getFriendlyFieldName('country') }}</mat-label>
          <mat-select name="country" formControlName='country' disabled>
            <mat-option value="New Zealand">New Zealand</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
